import { type FunctionComponent } from 'react';

import { Classes } from '@blueprintjs/core';

interface FormGroupingProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

const FormGrouping: FunctionComponent<FormGroupingProps> = ({ title, className, children }) => {
  return (
    <div className={`form-grouping ${Classes.ELEVATION_0} ${className ?? ''}`}>
      <b className="form-grouping__title">{title}</b>
      {children}
    </div>
  );
};

export default FormGrouping;
